import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * SR5 (Suporte e Resistência 5, FML.SR5) — overlay de preço, 10 linhas:
 * R1..R5 (resistências) e S1..S5 (suportes), na ordem do FormulaPackage do
 * engine [R1,S1,R2,S2,R3,S3,R4,S4,R5,S5]. yAccessor(d) retorna o objeto com as
 * 10 chaves.
 */
const LINES = [
  ["r1", "strokeR1"],
  ["s1", "strokeS1"],
  ["r2", "strokeR2"],
  ["s2", "strokeS2"],
  ["r3", "strokeR3"],
  ["s3", "strokeS3"],
  ["r4", "strokeR4"],
  ["s4", "strokeS4"],
  ["r5", "strokeR5"],
  ["s5", "strokeS5"],
];

class SR5Series extends Component {
  constructor(props) {
    super(props);
    // Um accessor por linha, criado uma única vez (nada de closure em render).
    this.accessors = LINES.reduce((acc, [key]) => {
      acc[key] = (d) => {
        const v = this.props.yAccessor(d);
        return v && v[key];
      };
      return acc;
    }, {});
  }
  render() {
    const { className } = this.props;
    return (
      <g className={className}>
        {LINES.map(([key, strokeProp]) => (
          <LineSeries
            key={key}
            yAccessor={this.accessors[key]}
            stroke={this.props[strokeProp]}
            fill="none"
          />
        ))}
      </g>
    );
  }
}

const strokeType = PropTypes.oneOfType([PropTypes.object, PropTypes.string]);

SR5Series.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  className: PropTypes.string,
  strokeR1: strokeType,
  strokeS1: strokeType,
  strokeR2: strokeType,
  strokeS2: strokeType,
  strokeR3: strokeType,
  strokeS3: strokeType,
  strokeR4: strokeType,
  strokeS4: strokeType,
  strokeR5: strokeType,
  strokeS5: strokeType,
};

SR5Series.defaultProps = {
  className: "react-stockcharts-sr5-series",
};

export default SR5Series;
